var _defs, _g, _use, _use2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeaturesIcon01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-100%",
    y: "-100%",
    width: "300%",
    height: "300%",
    filterUnits: "objectBoundingBox",
    id: "a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-3.6%",
    y: "-6.3%",
    width: "107.1%",
    height: "112.5%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.24 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-500.8%",
    y: "-876.4%",
    width: "1101.6%",
    height: "1852.7%",
    filterUnits: "objectBoundingBox",
    id: "f"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%",
    filterUnits: "objectBoundingBox",
    id: "g"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "98.16%",
    y1: "49.974%",
    x2: "0%",
    y2: "50%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818CF8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818CF8",
    offset: "50.119%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "109.459%",
    y1: "50%",
    x2: "0%",
    y2: "56.145%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818CF8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF2FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.06 8.636c-2.44-1.167-5.587-1.872-9.025-1.872-3.437 0-6.585.705-9.025 1.872H0v6.116c0 4.41 6.284 7.987 14.035 7.987 7.752 0 14.035-3.576 14.035-7.987V8.636h-5.01Z",
    id: "c"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#6366F1",
    cx: 28,
    cy: 28,
    r: 28
  }), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.8,
    fill: "#312E81",
    filter: "url(#a)",
    cx: 28,
    cy: 28,
    r: 12
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-25 57.729 -11.705)"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#c"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#d)",
    xlinkHref: "#c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.11 8.727c0 4.411-6.284 7.987-14.035 7.987C6.323 16.714.04 13.138.04 8.727S6.323.74 14.075.74c7.751 0 14.035 3.577 14.035 7.988",
    fill: "url(#e)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.39 9.036c0 1.512-2.147 2.738-4.793 2.738-2.647 0-4.793-1.226-4.793-2.738 0-1.513 2.146-2.74 4.793-2.74 2.646 0 4.792 1.227 4.792 2.74",
    fill: "#D6F1FF",
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#f)"
  }), /*#__PURE__*/React.createElement("circle", {
    fillOpacity: 0.32,
    fill: "#38BDF8",
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#g)",
    cx: 14,
    cy: 12,
    r: 12
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon01);
export default __webpack_public_path__ + "static/media/features-icon-01.f7d0f04d9898a84de994afb22ac15e37.svg";
export { ForwardRef as ReactComponent };